export enum TableColumnSize {
  XL = 300,
  L = 200,
  M = 150,
  S = 120,
  XS = 100,
  XXS = 80,
  ACTIONS = 20,
}
